export default function TextPlaceholder({
  lines = 4,
  rows = 1,
  theme = 'light',
}: {
  lines?: number
  rows?: number
  theme?: 'light' | 'dark'
}) {
  const getWidth = (index: number) => {
    const position = index % 4
    if (position === 0 || position === 3) return 'calc(100% - 40px)'
    if (position === 1) return 'calc(100% - 20px)'
    return '100%'
  }

  return (
    <div className="flex animate-pulse flex-col gap-2">
      {Array.from({ length: lines * rows }).map((_, i) => (
        <div
          key={i}
          className={`h-4 w-full rounded ${theme === 'dark' ? 'bg-white/20' : 'bg-gray-200'}`}
          style={{
            width: getWidth(i),
            marginTop: i % lines ? '0' : i !== 0 ? '16px' : 0,
          }}
        />
      ))}
    </div>
  )
}
